export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torso-business-2034d57992fdd558f81695842da4b7f1.svg";